import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AppRoute } from "app/app-layout/constants/app-route.enum";
import { AuthenticationGuard } from "app/core/authentication/authentication.guard";
import { FeatureCode } from "app/core/feature-control/models";
import { FeatureControlGuard } from "app/core/feature-control/guards";
import { HomeComponent } from "app/my-zone/home/components/home.component";

import { AppLayoutComponent } from "./components/app-layout/app-layout.component";
import { ReportsNavGuard } from "./models/nav/nav-guards/reports-nav.guard";

export const routes: Routes = [
  {
    canActivate: [AuthenticationGuard],
    path: "",
    component: AppLayoutComponent,
    children: [
      //////////////////////////////////
      // Global routes
      //////////////////////////////////
      {
        path: AppRoute.home,
        redirectTo: AppRoute.dashboard,
        pathMatch: "full",
      },

      //////////////////////////////////
      // My Zone routes
      //////////////////////////////////
      {
        path: AppRoute.myZone,
        redirectTo: AppRoute.dashboard,
        pathMatch: "full",
      },
      { path: AppRoute.dashboard, component: HomeComponent, pathMatch: "full" },
      {
        path: AppRoute.survey,
        loadChildren: "app/assessment/survey/survey.module#SurveyModule",
      },
      {
        path: AppRoute.evaluation,
        loadChildren:
          "app/assessment/evaluation/evaluation.module#EvaluationModule",
      },
      {
        path: AppRoute.equipment,
        loadChildren:
          "app/my-zone/equipment-dashboard/equipment-dashboard.module#EquipmentDashboardModule",
      },

      //////////////////////////////////
      // Reports routes
      //////////////////////////////////
      {
        path: AppRoute.reports,
        redirectTo: AppRoute.managementOverview,
        pathMatch: "full",
      },
      {
        canActivate: [ReportsNavGuard],
        path: AppRoute.managementOverview,
        loadChildren:
          "app/reports/management-overview/management-overview.module#ManagementOverviewModule",
      },
      {
        canActivate: [ReportsNavGuard],
        path: AppRoute.assessmentResults,
        loadChildren:
          "app/reports/assessment-results/assessment-results.module#AssessmentResultsModule",
      },
      {
        canActivate: [ReportsNavGuard],
        path: AppRoute.workload,
        loadChildren: "app/reports/workload/workload.module#WorkloadModule",
      },
      {
        canActivate: [ReportsNavGuard],
        path: AppRoute.activityReport,
        loadChildren:
          "app/reports/activity-reports/activity-reports.module#ActivityReportsModule",
      },
      {
        canActivate: [ReportsNavGuard, FeatureControlGuard],
        path: AppRoute.equipmentReport,
        loadChildren:
          "app/reports/equipment-report/equipment-report.module#EquipmentReportModule",
        data: { featureCode: FeatureCode.EQUIPMENT_REPORT },
      },
      {
        path: AppRoute.executiveSummary,
        loadChildren:
          "app/reports/executive-summary/executive-summary.module#ExecutiveSummaryModule",
      },
      {
        path: AppRoute.gapAssessment,
        loadChildren:
          "app/reports/gap-assessment/gap-assessment.module#GapAssessmentModule",
      },
      {
        path: AppRoute.returnOnInvestment,
        loadChildren:
          "app/reports/return-on-investment/return-on-investment.module#ReturnOnInvestmentModule",
      },

      //////////////////////////////////
      // Training routes
      //////////////////////////////////
      {
        path: AppRoute.training,
        loadChildren: "app/training/training.module#TrainingModule",
      },

      //////////////////////////////////
      // Administration routes
      //////////////////////////////////
      {
        path: AppRoute.administration,
        loadChildren:
          "app/administration/administration.module#AdministrationModule",
      },

      //////////////////////////////////
      // Help routes
      //////////////////////////////////
      { path: AppRoute.help, loadChildren: "app/help/help.module#HelpModule" },

      //////////////////////////////////
      // Users routes
      //////////////////////////////////
      {
        path: AppRoute.users,
        redirectTo: AppRoute.systemUsers,
        pathMatch: "full",
      },
      {
        path: AppRoute.systemUsers,
        loadChildren: "app/users/users.module#UsersModule",
      },
    ],
  },
];

export const routedComponents: any[] = [AppLayoutComponent];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppLayoutRoutingModule {}
